import * as React from 'react';

import { mobilePaytablePortraitConfigurationContext, frameworkMobilePaytablePortrait } from './mobilePaytablePortraitconfiguration';

const withMobilePaytableConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <mobilePaytablePortraitConfigurationContext.Consumer>
            {(): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkMobilePaytablePortrait} />
                );
            }}
        </mobilePaytablePortraitConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withMobilePaytableConfiguration;